module.exports = __webpack_public_path__ + "static/media/multirojo75.6efba85c.gif";